import OMapObjectInfoOtg from './o-map-object-info-otg.vue';

export default OMapObjectInfoOtg;